/**
 * /account-health — the signed-in admin's own account safety.
 *
 * A thin shim per the feature-folder golden path: prefetch, mount the page, no domain logic.
 *
 * No beforeLoad role gate. This is the caller's OWN posture on the /me tree, resolved from their session,
 * so every admin who can sign in has exactly one account to see here and it is theirs — a tenant-scope
 * admin is as entitled to it as a platform admin. The gate that matters is on the server
 * (RequireUserOrAdminSelfRead), which admits this one read and refuses the rest of /me.
 */

import { createFileRoute } from "@tanstack/react-router";

import { fetchAccountHealth } from "@/features/account-health/queries";
import { AccountHealthPage } from "@/features/account-health/pages/account-health-page";
import { queryKeys } from "@/lib/query-keys";

export const Route = createFileRoute("/_authed/account-health")({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData({
      queryKey: queryKeys.accountHealth,
      queryFn: fetchAccountHealth,
    });
  },
  component: AccountHealthPage,
});
